import AggregableColumnManager from '../aggregable/AggregableColumnManager';

export default class ImportTradesColumnManager extends AggregableColumnManager {
}